export default __webpack_public_path__ + "static/media/mobile_applications_m.c8fc7c47.jpg";